import React from 'react'
import PropTypes from 'prop-types'

import DataTable from 'components/organisms/DataTable'
import PaginationControl from 'components/organisms/PaginationControl'

import { userTrapColumns } from '.'

const UserTraps = ({
  traps,
  filters,
  tableLoading,
  onPageChange,
  onTableSortClick
}) => (
  <React.Fragment>
    <DataTable
      dataProvider={traps}
      columns={userTrapColumns}
      tableLoading={tableLoading}
      onSortClick={onTableSortClick}
      emptyStateTitle="This user has not installed any traps"
      emptyStateDescription="Any traps that the user installs will appear here"
    />
    <PaginationControl pagination={filters.pagination} onPageChange={onPageChange} />
  </React.Fragment>
)

UserTraps.propTypes = {
  traps: PropTypes.object,
  filters: PropTypes.object,
  tableLoading: PropTypes.bool,
  onPageChange: PropTypes.func,
  onTableSortClick: PropTypes.func,
}

export default UserTraps



// WEBPACK FOOTER //
// ./src/components/organisms/UserTraps/UserTraps.js